import Model from './BaseModel'

export default class Color extends Model {
    resourceName() {
        return 'colors'
    }

    fields() {
        return [
            'id',
            'navigation_background',
            'menu_background',
            'highlight_background',
            'navigation_text',
            'menu_text',
            'highlight_text',
        ]
    }
}
